import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'outcomesSummaryTable',
    label: 'Outcomes Summary Table',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
